import React from 'react'
import { getCartItemProductOption } from '@components/cart/helpers'

type CartItemOptionProps = {
  property: string
  value: string
  newLine?: boolean
}

const CartItemOption = ({ property, value, newLine }: CartItemOptionProps) => {
  return (
    <span>
      {getCartItemProductOption(property, value)}
      {newLine && <br />}
    </span>
  )
}

export default CartItemOption
